import { Injectable } from '@angular/core'; 
import { AppEnum } from './appenum';
import { EncryptionService } from './services/encryption.service';

@Injectable()
export class AppSettings { 
    public selectedLanguage = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale)); 
    constructor(
        private encryptionService: EncryptionService,private _appenum: AppEnum
    ){}  
}

